import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Grid, Tabs, Tab, Button, IconButton, CssBaseline, MenuItem, Tooltip, Divider, Collapse, MenuList, Paper, Popper, Grow, Typography, Stack,
         Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import { useTheme ,ThemeProvider, createTheme } from "@mui/material/styles";
import { toast } from 'react-toastify';
import { Close as CloseIcon, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon,
          NoteAddOutlined as NoteAddOutlinedIcon, FileOpenOutlined as FileOpenOutlinedIcon, MemoryOutlined as MemoryOutlinedIcon,DeveloperBoardOutlined as DeveloperBoardOutlinedIcon,
          DeveloperBoard as DeveloperBoardIcon, FiberPinOutlined as FiberPinOutlinedIcon, FiberManualRecord as FiberManualRecordIcon } from "@mui/icons-material";

import './SchematicEditor.css';
import { VIEW_TYPES } from "../../constants/Constants";
import { mxCell, mxCodec, mxEvent, mxGeometry, mxGraph, mxGraphHandler, mxGraphModel, mxPoint, 
         mxUtils, mxResources,  mxOutline} from "../../utils/graph/mxModule";
import { Common } from "../../utils/common";
import { addRectAndPins, editRectAndPins } from "../../utils/graph/symbolConfig";
import { buildGraphObject, graphHandlerInits, graphPrototypeInits, mxConstraintHandlerInit } from "../../utils/graph/graphSettings";
import { registerCustomShapes, shapeConfigRegistry } from "../../utils/graph/registerShapes";
import { encrypt } from "../../utils/encryption";

import GraphToolbar from "../Diagram/GraphToolbar";
import NewCellDialog from "../Cell/NewCellDialog";
import AddInstanceDialog from "../Instance/AddInstanceDialog.";
import AddPinDialog from "../Pin/AddPinDialog";
import AddSymbol from "../Symbol/AddSymbol";
import EditCellDiagram from "../Cell/EditCellDiagram";

import { addCell } from "../../services/cellService";
import { addView } from "../../services/viewService";
import { getViewById, updateViewDiagram, getNetlistByViewId } from "../../services/viewService";
import { getSymbolSpecificationByViewId } from "../../services/symbolSpecification";

import UnsavedDialog from "./UnsavedDialog";
import NetlistDialog from "./NetlistDialog";
import { addStylesBackToXml, extractAndRemoveStyles, removeMxGraphWrappers, wrapMxGraphModel } from "../../utils/MxGraphXml";
import { getAllNetEdges, getConnectedNetName, propagateBestNetName, applyNetLabel, reEvaluateNetName } from "../../utils/graph/netUtils";
import ManageLibrary from "../LibraryManager/ManageLibrary";
import MinimizedBar from "../Instance/MinimizedBar";

const SchematicEditor = ({openHeader,toggleHeader, setIsEditorOpen}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mode, setMode] = useState(localStorage.getItem('theme-mode') || 'dark');
  const theme = useTheme();

  const localTheme = createTheme({
      palette: {
        mode,
      },
    });

    const toggleMode = () => {
      setMode((prev) => {
        const newMode = prev === 'light' ? 'dark' : 'light';
        localStorage.setItem('theme-mode', newMode); 
        return newMode;
      });
    };

    const isDarkMode = (mode === 'dark');

    // State for tabs management
    const [tabs, setTabs] = useState([]);
    
    const [activeTab, setActiveTab] = useState();
    const [dialogOpen, setDialogOpen] = useState(false);
    // const [newTabName, setNewTabName] = useState("");
    const [graphReadyTabs, setGraphReadyTabs] = useState({});
    // const [open, setOpen] = useState(true);
    const [newCellopen, setNewCellOpen] = useState(false);    
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);
    const [openAddInstance, setOpenAddInstance] = useState(false);
    const [openAddPin, setOpenAddPin] = useState(false);
    const [openAddSymbol, setOpenAddSymbol] = useState(false);
    const [isDiagramEmpty, setIsDiagramEmpty] = useState(true);

    const insertModeRef = useRef(false);
    const insertCellRef = useRef(null);
    const previewRef = useRef(null);
    const instanceCountersRef = useRef({});
    // const instanceCounterRef = useRef(1);
    const instancesMapRef = useRef({});
    const currentInstancePrefixRef = useRef('i');
    const isInstanceNameValidRef = useRef(true);
    const selectedShapeTypeRef = useRef('');
    const selectedIconPathRef = useRef('');
    const [selectedGraphCell, setSelectedGraphCell] = useState(null);
    const [nextInstanceName, setNextInstanceName] = useState("i1");
    // const [editData,setEditData] = useState("");
    // const [openDialog, setOpenDialog] = useState(false);
    // const [gXml, setGXml] = useState("");
        
    const [isEditInstance, setIsEditInstance] = useState(false);
    const [editInstanceName, setEditInstanceName] = useState('');

    const [isEditPin, setIsEditPin] = useState(false);
    const [editPinName, setEditPinName] = useState('');
    const pinMapRef = useRef({});
    const [menuVisible, setMenuVisible] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const [saveEnabled, setSaveEnabled] = useState({});
    const [isSelectionEmpty, setIsSelectionEmpty] = useState(true);    
    const containerRefs = useRef({});
    const graphRefs = useRef({});
    const commonRefs = useRef({});
    const outlineRef = useRef({});
    const [graphType, setGraphType] = useState('');
    const [hasClipboardContent, setHasClipboardContent] = useState(false);
    const [cellViewPayload, setCellViewPayload] = useState({});
    const [editCellDialog, setEditCellDialog] = useState(false);
    const [openUnsavedDialog, setOpenUnsavedDialog] = useState(false);
    const [selectedCellName, setSelectedCellName] = useState('');
    const [selectedTabId, setSelectedTabId] = useState();
    const [isHovered, setIsHovered] = useState(false);
    const [isOutLineVisible, setIsOutLineVisible] = useState({});    
    const [pinQueue, setPinQueue] = useState([]);
    const [openManageLibrary, setOpenManageLibrary] = useState(false);
    const pinQueueRef = useRef([]);
    const currentInstanceNameRef = useRef('');
    const isSilentUpdate = useRef(false);
    const isDarkModeRef = useRef(isDarkMode);
    const userId = localStorage.getItem('user_id')

    // Net naming
    const netCountersRef = useRef({});
    const noConnCountersRef = useRef({});

    const [openNetLabelDialog, setOpenNetLabelDialog] = useState(false);
    const [editingNetCell, setEditingNetCell] = useState(null);
    const [netLabelValue, setNetLabelValue] = useState('');

    // Netlist viewer
    const [openNetlistDialog, setOpenNetlistDialog] = useState(false);
    const [netlistText, setNetlistText] = useState('');

    // Instance Minimizing state
    const [isInstanceMinimized, setIsInstanceMinimized] = useState(false);
    const [dialogKey, setDialogKey] = useState(0);

    const normalizeInstanceName = (name) => (name || '').trim().toLowerCase();

    const splitNameAndSuffix = (name) => {
      const trimmed = (name || '').trim();
      const match = trimmed.match(/^(.*?)(\d+)$/);
      if (!match) return { base: trimmed || 'i', number: null };
      return { base: match[1] || 'i', number: Number(match[2]) };
    };

    const isReservedInstanceName = (name) => (name || '').trim() === 'no-conn';

    const ensureTabInstanceState = (tabId) => {
      if (!instancesMapRef.current[tabId]) {
        instancesMapRef.current[tabId] = {};
      }
      if (!instanceCountersRef.current[tabId] || typeof instanceCountersRef.current[tabId] !== 'object') {
        instanceCountersRef.current[tabId] = { i: Number(instanceCountersRef.current[tabId]) || 1 };
      }
      return {
        instances: instancesMapRef.current[tabId],
        counters: instanceCountersRef.current[tabId],
      };
    };

    const isNoConnCell = (cell) => (cell?.style || '').includes('shape=no-conn') || isReservedInstanceName(cell?.value);

    const getTabInstanceNames = (tabId = activeTab, excludeCell = null) => {
      const graph = graphRefs.current[tabId];
      const names = new Set();

      Object.entries(instancesMapRef.current[tabId] || {}).forEach(([name, entry]) => {
        if (!excludeCell || entry?.cell !== excludeCell) {
          names.add(normalizeInstanceName(name));
        }
      });

      if (graph) {
        graph.getChildVertices(graph.getDefaultParent()).forEach((cell) => {
          if (cell === excludeCell || isNoConnCell(cell)) return;
          const value = (cell.value || '').trim();
          if (value) names.add(normalizeInstanceName(value));
        });
      }

      return names;
    };

    const isInstanceNameAvailable = (name, tabId = activeTab, excludeCell = null) => {
      const trimmed = (name || '').trim();
      if (!trimmed || isReservedInstanceName(trimmed)) return true;
      return !getTabInstanceNames(tabId, excludeCell).has(normalizeInstanceName(trimmed));
    };

    const instanceCounter = (tabId, name) => {
      const trimmed = (name || '').trim();
      if (!trimmed || isReservedInstanceName(trimmed)) return;
      const { counters } = ensureTabInstanceState(tabId);
      const { base, number } = splitNameAndSuffix(trimmed);
      const prefix = base || 'i';
      counters[prefix] = Math.max(counters[prefix] || 1, (number || 0) + 1);
    };

    const getNextInstanceNameForTab = (tabId = activeTab, prefixHint = 'i') => {
      const { counters } = ensureTabInstanceState(tabId);
      const { base, number } = splitNameAndSuffix(prefixHint);
      const prefix = base || 'i';
      let next = number == null ? (counters[prefix] || 1) : number + 1;
      let candidate = `${prefix}${next}`;
      const existing = getTabInstanceNames(tabId);

      while (existing.has(normalizeInstanceName(candidate))) {
        next += 1;
        candidate = `${prefix}${next}`;
      }

      counters[prefix] = next;
      return candidate;
    };

    const registerInstanceName = (tabId, name, cell, shapeType, libraryId) => {
      const trimmed = (name || '').trim();
      if (!trimmed || isReservedInstanceName(trimmed)) return;
      const { instances } = ensureTabInstanceState(tabId);
      instances[trimmed] = { cell, shapeType, libraryId };
      instanceCounter(tabId, trimmed);
    };

    const unregisterInstanceName = (tabId, name) => {
      const trimmed = (name || '').trim();
      if (!trimmed || !instancesMapRef.current[tabId]) return;
      delete instancesMapRef.current[tabId][trimmed];
    };

    const rebuildInstanceStateForTab = (tabId, graph) => {
      instancesMapRef.current[tabId] = {};
      instanceCountersRef.current[tabId] = { i: 1 };
      if (!graph) return;
      graph.getChildVertices(graph.getDefaultParent()).forEach((cell) => {
        if (isNoConnCell(cell)) return;
        registerInstanceName(tabId, cell.value, cell, cell.style, cell.libraryId);
      });
    };

    const getCopyInstanceName = (tabId, originalName) => {
      const { base, number } = splitNameAndSuffix(originalName);
      const prefixHint = number == null ? `${base}0` : base;
      return getNextInstanceNameForTab(tabId, prefixHint);
    };

    const createOutlineContainer = (tabId, graph) => {
      const outlineContainer = outlineRef.current[tabId];
      if (outlineContainer && graph) {
        new mxOutline(graph, outlineContainer);
      }
    };


    const initializeGraphForSymbol = (tabId, data = null, rect=null, pins=null) => {
      const container = containerRefs.current[tabId];
      if (!container) return;
      container.innerHTML = ""; // Clear previous content
      const graph = new mxGraph(container);
      graphRefs.current[tabId] = graph;  
      graphRefs.current[tabId].view_type_id = VIEW_TYPES.symbol;    
      commonRefs.current[tabId] = new Common(graph);

      // Get the pin data for this tab
      const symbolData = data || cellViewPayload[tabId];
      const pinConfig = symbolData?.pins || [];

      graph.getModel().beginUpdate();
      try {
        // addRectAndPins(container, graph);
        if (symbolData?.view_id) {
          // Edit existing symbol
          editRectAndPins(container, graph, rect, pins, symbolData.cell_name);
        } else {
          // New symbol
          addRectAndPins(container, graph, pinConfig, symbolData?.cell_name);
        }
      } finally {
        graph.getModel().endUpdate();
      }

      // This prevents undo from reverting the loaded diagram
      if (commonRefs.current[tabId]) {
        commonRefs.current[tabId]._undoManager.clear();
      }

      // Add change listener for symbol modifications
      graph.getModel().addListener(mxEvent.CHANGE, () => {
        if (isSilentUpdate.current) return; // Ignore silent updates
        setSaveEnabled(prev => {
          if (prev[tabId]) return prev;
          return {
            ...prev,
            [tabId]: true,
          };
        });
      });

      // Track selection changes
      graph.getSelectionModel().addListener(mxEvent.CHANGE, () => {
        setIsSelectionEmpty(graph.isSelectionEmpty());
      });

      setGraphReadyTabs((prev) => ({
        ...prev,
        [tabId]: true,
      }));
    }

      const initializeGraph = (tabId) => {
      const container = containerRefs.current[tabId];
      if (!container) return;
  
      container.innerHTML = ""; // Clear previous content
      const graph = new mxGraph(container);
      ensureTabInstanceState(tabId);

      const originalImportCells = graph.importCells.bind(graph);
      graph.importCells = function (cells, dx, dy, target, evt, mapping) {
        // Snapshot existing names BEFORE paste
        const existingBeforePaste = new Set();
        Object.keys(instancesMapRef.current[tabId] || {}).forEach(n => {
          existingBeforePaste.add(normalizeInstanceName(n));
        });
        graph.getChildVertices(graph.getDefaultParent()).forEach((cell) => {
          if (isNoConnCell(cell)) return;
          const value = (cell.value || '').trim();
          if (value) existingBeforePaste.add(normalizeInstanceName(value));
        });

        // Wrap everything in single beginUpdate so paste + rename = one undo step
        graph.getModel().beginUpdate();
        const importedCells = originalImportCells(cells, dx, dy, target, evt, mapping);
        try {
          const assignedThisPaste = new Set();

          (importedCells || []).forEach((cell) => {
            if (!cell?.isVertex?.() || isNoConnCell(cell)) return;
            if (cell.getParent?.() !== graph.getDefaultParent()) return;

            const oldName = (cell.value || '').trim();
            const { base } = splitNameAndSuffix(oldName);

            if (base !== 'i') {
              // Custom name (myInv, xor1 etc.) — keep if free, else find next available with same prefix
              if (!existingBeforePaste.has(normalizeInstanceName(oldName)) &&
                  !assignedThisPaste.has(normalizeInstanceName(oldName))) {
                // Free — keep original name
                registerInstanceName(tabId, oldName, cell, cell.style, cell.libraryId);
                assignedThisPaste.add(normalizeInstanceName(oldName));
                return;
              }
              // Conflict — find next with same prefix
              const { number } = splitNameAndSuffix(oldName);
              let next = 1;
              let candidate = `${base}${next}`;
              while (
                existingBeforePaste.has(normalizeInstanceName(candidate)) ||
                assignedThisPaste.has(normalizeInstanceName(candidate))
              ) {
                next += 1;
                candidate = `${base}${next}`;
              }
              graph.getModel().setValue(cell, candidate);
              registerInstanceName(tabId, candidate, cell, cell.style, cell.libraryId);
              assignedThisPaste.add(normalizeInstanceName(candidate));
              return;
            }

            // 'i' prefix — always find next available from i1
            let next = 1;
            let candidate = `i${next}`;
            while (
              existingBeforePaste.has(normalizeInstanceName(candidate)) ||
              assignedThisPaste.has(normalizeInstanceName(candidate))
            ) {
              next += 1;
              candidate = `i${next}`;
            }
            graph.getModel().setValue(cell, candidate);
            registerInstanceName(tabId, candidate, cell, cell.style, cell.libraryId);
            assignedThisPaste.add(normalizeInstanceName(candidate));
          });
        } finally {
          graph.getModel().endUpdate();
        }

        return importedCells;
      };
      
//    graph.connectionHandler.createEdgeState = function(me) {
//      const style = 'edgeStyle=orthogonalEdgeStyle;movable=true;resizable=true;';
//   const edge = new mxCell('', new mxGeometry(), style);
//   edge.setEdge(true);
//   return new mxCellState(this.graph.view, edge, this.graph.getCellStyle(edge));
// };

      graph.connectionHandler.insertEdge = function (parent, id, value, source, target, style) {
        if (!netCountersRef.current[tabId]) netCountersRef.current[tabId] = 1;

        // Source takes priority over target for net name inheritance
        const sourceNet = getConnectedNetName(graph, source, noConnCountersRef, tabId);
        const targetNet = getConnectedNetName(graph, target, noConnCountersRef, tabId);
        const inheritedNetName = (sourceNet?.startsWith('no-conn_') ? sourceNet : null) || (targetNet?.startsWith('no-conn_') ? targetNet : null) || sourceNet || targetNet;
        const autoNetName = inheritedNetName || `net_${netCountersRef.current[tabId]++}`;

        const edge = graph.createEdge(parent, id, autoNetName, source, target, style);
        edge.geometry = new mxGeometry();
        edge.geometry.relative = true;
        const edgeFontColor = isDarkModeRef.current ? '#ffffff' : '#000000';
        edge.style = (edge.style || '') + `;noLabel=1;fontColor=${edgeFontColor};labelBackgroundColor=none`;

        graph.getModel().beginUpdate();
        try {
          graph.addEdge(edge, parent, source, target);
          if (!target) {
            graph.removeCells([edge]);
            return null;
          }
          // Propagate highest-priority net name to all connected edges
          propagateBestNetName(graph, edge, source, target);
          return edge;
        } finally {
          graph.getModel().endUpdate();
        }
      };

      // When edges are deleted, re-evaluate the net name for surviving connected edges.
      const _originalRemoveCells = graph.removeCells.bind(graph);
      graph.removeCells = function (cells, includeEdges) {
        const model = graph.getModel();
        const deletedIds = new Set((cells || []).map(c => c.id));
        const removedInstanceNames = [];
        (cells || []).forEach((cell) => {
          if (!model.isVertex(cell) || isNoConnCell(cell)) return;
          if (model.getParent(cell) === graph.getDefaultParent()) {
            removedInstanceNames.push(cell.value);
          }
        });

        // Detect pin deletions
        // When a pin vertex is deleted, mxGraph auto-deletes its directly connected edges. But edges connected will still carry the pin name.
        // Collect those surviving edges now (before removal) so we can re-evaluate their net names after the pin is gone.
        const deletedPinEdges = [];
        (cells || []).forEach((cell) => {
          if (!model.isVertex(cell)) return;
          const style = model.getStyle(cell) || '';
          const isPin =
            style.includes('shape=in') ||
            style.includes('shape=out') ||
            style.includes('shape=inout');
          if (!isPin) return;

          // Traverse entire net from pin, collect all surviving edges
          graph.getEdges(cell).forEach((edge) => {
            const allNetEdges = getAllNetEdges(graph, edge);
            allNetEdges.forEach((netEdge) => {
              if (!deletedIds.has(netEdge.id)) {
                deletedPinEdges.push(netEdge);
              }
            });
          });
        });

        // BEFORE removal: capture terminals of each deleted edge so we can
        // re-evaluate the surviving sub-nets after deletion.
        // Each entry: { terminals: [src, tgt], netEdgesBefore: [...surviving edges] }
        const removalInfo = [];
        (cells || []).forEach(cell => {
          if (!model.isEdge(cell)) return;
          const src = model.getTerminal(cell, true);
          const tgt = model.getTerminal(cell, false);
          // Snapshot which edges (other than those being deleted) are in this net now,
          // grouped by the two sides of the deleted edge, so that after deletion we
          // can evaluate each potentially-split sub-net independently.
          const netEdges = getAllNetEdges(graph, cell);
          const survivingEdges = netEdges.filter(e => !deletedIds.has(e.id));
          removalInfo.push({ src, tgt, survivingEdges });
        });

        const result = _originalRemoveCells(cells, includeEdges);
        removedInstanceNames.forEach((name) => unregisterInstanceName(tabId, name));

        // AFTER removal: re-evaluate each surviving sub-net independently.
        // Two terminals of the deleted edge may now belong to separate, disconnected
        // sub-nets, so we evaluate starting from each terminal's side separately.
        const processed = new Set();

        const evalFromTerminal = (terminal) => {
          if (!terminal || processed.has(terminal.id)) return;
          processed.add(terminal.id);

          let seedEdge = null;
          if (model.isEdge(terminal) && model.getParent(terminal) !== null) {
            seedEdge = terminal;
          } else if (model.isVertex(terminal)) {
            const edges = graph.getEdges(terminal).filter(e => model.getParent(e) !== null);
            if (edges.length > 0) seedEdge = edges[0];
          }
          if (seedEdge) reEvaluateNetName(graph, seedEdge, netCountersRef, tabId);
        };

        removalInfo.forEach(({ src, tgt }) => {
          evalFromTerminal(src);
          evalFromTerminal(tgt);
        });

        // Re-evaluate edges that survived pin deletion. If these edges still carry the deleted pin's name, Then assign fresh net names.
        const pinEdgeProcessed = new Set();
        deletedPinEdges.forEach((edge) => {
          if (
            model.getParent(edge) !== null &&
            !pinEdgeProcessed.has(edge.id)
          ) {
            pinEdgeProcessed.add(edge.id);
            reEvaluateNetName(graph, edge, netCountersRef, tabId);
          }
        });

        return result;
      };

      createOutlineContainer(tabId, graph);

      graph.setEnabled(true);
      graphRefs.current[tabId] = graph;
      graphRefs.current[tabId].view_type_id = VIEW_TYPES.schematic;
      // commonRefs.current[tabId] = new Common(graph);
      commonRefs.current[tabId] = new Common(graph, (hasContent) => {
        setHasClipboardContent(hasContent);
      });

      // Set up change listener to track modifications
        graph.getModel().addListener(mxEvent.CHANGE, () => {
          if (isSilentUpdate.current) return; // Ignore silent updates
          setSaveEnabled(prev => {
            if (prev[tabId]) return prev;
            return {
              ...prev,
              [tabId]: true,
            };
          });
        });
        // Track selection changes separately
      graph.getSelectionModel().addListener(mxEvent.CHANGE, () => {
        setIsSelectionEmpty(graph.isSelectionEmpty());
      });
  
      setGraphReadyTabs((prev) => ({
        ...prev,
        [tabId]: true,
      }));

      setIsOutLineVisible((prev) => ({
        ...prev,
        [tabId]: true,
      }));
      
      graphHandlerInits(graphRefs.current[tabId]);
      mxConstraintHandlerInit(isDarkMode);
      buildGraphObject(graphRefs.current[tabId]);      
      registerCustomShapes();
      addGraphListeners(tabId, graphRefs.current[tabId]);   //This is not moved to common class intentionally   
    };
  

    function addGraphListeners(tabId, graph){

      graph.addListener(mxEvent.CLICK, function (sender, evt) {
        const mouseEvent = evt.getProperty('event');
        if (mouseEvent.button !== 0 || !insertModeRef.current || !insertCellRef.current) return;
        const pt = graph.getPointForEvent(mouseEvent);
        const originalCell = insertCellRef.current;
        const clone = graph.getModel().cloneCell(originalCell);

        const width = clone.geometry.width;
        const height = clone.geometry.height;

        clone.geometry.x = pt.x - width / 2;
        clone.geometry.y = pt.y - height / 2;

        const libraryId = insertCellRef.current.libraryId || '';
        const isPlacingPins = pinQueueRef.current.length > 0;

        if (isPlacingPins) {
          // Pin Placement

          const currentLabel = pinQueueRef.current[0];
          clone.value = currentLabel;

          graph.getModel().beginUpdate();
          try {
            graph.addCell(clone);
            graph.setSelectionCell(clone);
          } finally {
            graph.getModel().endUpdate();
          }

          // Remove the placed pin label from queue
          pinQueueRef.current.shift();
          setPinQueue([...pinQueueRef.current]);

          if (pinQueueRef.current.length === 0) {
            // No more pins to place — clear everything
            clearPinPlacement();
            return;
          }

          // Show next pin ghost
          previewRef.current?.remove();
          previewRef.current = null;

          setTimeout(() => {
            const nextLabel = pinQueueRef.current[0];
            createGhostPin(selectedShapeTypeRef.current, selectedIconPathRef.current, nextLabel, libraryId);
          }, 50);

        } else {
          // CLEAR OLD PIN SELECTION (IMPORTANT FIX)
          setSelectedGraphCell(null);
          setIsEditPin(false);
          // Instance placement logic (Non-pin)
          const typedName = currentInstanceNameRef.current?.trim();

          ensureTabInstanceState(tabId);

          let instanceName;

          if (originalCell.style.includes("shape=no-conn")) {
            instanceName = "no-conn";
          } else {
            if (!isInstanceNameValidRef.current) return;
            instanceName = typedName || getNextInstanceNameForTab(tabId, 'i');
            if (!isInstanceNameAvailable(instanceName, tabId)) return;
          }

          clone.value = instanceName;

          registerInstanceName(tabId, instanceName, clone, originalCell.style, libraryId);

          graph.getModel().beginUpdate();
          try {
            graph.addCell(clone);
            graph.setSelectionCell(clone);
          } finally {
            graph.getModel().endUpdate();
          }

          currentInstanceNameRef.current = ''; // Clear after placement
          // FIX: reset edit mode
          setIsEditInstance(false);
          if (!originalCell.style.includes("shape=no-conn")) {
            setNextInstanceName(getNextInstanceNameForTab(tabId, 'i'));
          } else {
            setNextInstanceName("no-conn");
          }
        }
      });

      graph.addListener(mxEvent.DOUBLE_CLICK, function (sender, evt) {
        const cell = evt.getProperty('cell');
        if (!cell) return;
        evt.consume(); // Prevent mxGraph default in-place editing for all cases

        const model = graph.getModel();

        // --- Edge (wire) → rename net ---
        if (model.isEdge(cell)) {
          graph.connectionHandler.reset();
          setEditingNetCell(cell);
          setNetLabelValue(cell.value || '');
          setOpenNetLabelDialog(true);
          return;
        }

        if (model.isVertex(cell)) {
          const parent = model.getParent(cell);

          // --- Port child cell → assign net label ---
          // Reset connection handler to cancel any in-progress wire draw
          // that was started by the mouseDown half of this double-click
          if (model.isVertex(parent)) {
            graph.connectionHandler.reset();
            setEditingNetCell(cell);
            setNetLabelValue(cell.value || '');
            setOpenNetLabelDialog(true);
            return;
          }

          const style = cell.style || "";

          // --- Pin shape ---
          const isPin = style.includes("shape=in") || style.includes("shape=out") || style.includes("shape=inout");
          if (isPin) {
            setSelectedGraphCell(cell);
            setEditPinName(cell.value);
            setIsEditPin(true);
            setOpenAddPin(true);
            return;
          }

          // --- Instance ---
          setSelectedGraphCell(cell);  
          setNextInstanceName(cell.value);  
          setEditInstanceName(cell.value);
          setIsEditInstance(true);  
          setOpenAddInstance(true);
        }
      });
    }

    useEffect(() => {
      graphPrototypeInits(null, null, isDarkMode);
    }, []);
      
    //Triggers when tab is created, while switching the tab.
    useEffect(() => {
       if (!activeTab) return;
      setIsEditorOpen(tabs.length >= 1);
      //instance name refresh when tab changes 
      // if(activeTab){
      ensureTabInstanceState(activeTab);
      setNextInstanceName(getNextInstanceNameForTab(activeTab, 'i'));
      setIsEditInstance(false);
      // }
      // end

      const active = tabs.find((t) => t.id === activeTab);

      const container = containerRefs.current[activeTab];
      if (graphType == VIEW_TYPES.schematic) {
        if (active && !graphRefs.current[active.id]) {
          //console.log(graphType)
          initializeGraph(active.id);
        }
      } else if (graphType == VIEW_TYPES.symbol) {
        if (active && !graphRefs.current[active.id]) {
          //console.log(graphType)
          initializeGraphForSymbol(active.id);
        }
      } 

      //To enable the top, right, bottom, left keys to move the cells/vertex
      Object.entries(commonRefs.current).forEach(([tabId, common]) => {
        // Make sure tabId and activeTab are same type for comparison
        if (tabId === String(activeTab)) {
          common?.registerKeyHandlers?.();
        } else {
          common?.disposeKeyHandlers?.();
        }
      });
      setGraphType('');
      container?.focus();
      //reset the editor-open 
      return () => setIsEditorOpen(false);
    }, [activeTab, tabs]);

    //triggers during the light/dark mode toggle
    useEffect(() => {
    isDarkModeRef.current = isDarkMode;
    mxGraphHandler.prototype.previewColor = isDarkMode ? '#ffffff' : '#000000';
    if (!graphRefs.current[activeTab]) return;
    const graph = graphRefs.current[activeTab];

    // Keep the default edge stylesheet in sync so newly drawn edges inherit the right colors
    const defaultEdgeStyle = graph.getStylesheet().getDefaultEdgeStyle();
    defaultEdgeStyle['fontColor'] = isDarkMode ? '#ffffff' : '#000000';
    defaultEdgeStyle['labelBackgroundColor'] = 'none';

    isSilentUpdate.current = true; // Mark as silent
    // Use the new function to update all colors
    updateAllFontAndEdgeColors(graph, isDarkMode);
    isSilentUpdate.current = false; // Reset

    // Update constraint highlight color dynamically
    mxConstraintHandlerInit(isDarkMode);

    if (containerRefs.current[activeTab]) {
      containerRefs.current[activeTab].style.height = `${containerRefs.current[activeTab].scrollHeight}px`;
    }
    graphRefs.current[activeTab].refresh();
  }, [mode]);

  //THis is called when the tab is created. When the cells are selected in the add instance popup, 
  // the preview should not be displayed  on the popup. This useEffect handles the behaviour.
  useEffect(() => {
    if (!graphRefs.current[activeTab]) return;
    

    // Graph model change listener
    const modelListener = () => checkIfDiagramIsEmpty();
    graphRefs.current[activeTab].getModel().addListener(mxEvent.CHANGE, modelListener);

  commonRefs.current[activeTab]?.delete(instancesMapRef);
    const handleMouseMove = (e) => {

      if (insertModeRef.current && previewRef.current && containerRefs.current[activeTab]) {
        const rect = containerRefs.current[activeTab].getBoundingClientRect();
        const isInsideGraph =
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom;

        // const isOverPopup = addInstanceRef.current?.contains(e.target);
        // const dialogContent = document.querySelector('[role="dialog"]');
        const isOverDialog = e.target.closest('.MuiDialog-container, .MuiPopover-root, .MuiModal-root') !== null;
        // const isOverPopup = dialogContent?.contains(e.target);
        // console.log("aaa", isOverPopup ,e.target ,dialogContent)

        if (isInsideGraph && !isOverDialog) {
          const offsetX = e.clientX - rect.left;
          const offsetY = e.clientY - rect.top;

          previewRef.current.style.left = `${offsetX - 30}px`;
          previewRef.current.style.top = `${offsetY - 45}px`;
          previewRef.current.style.display = "block";
        } else {
          previewRef.current.style.display = "none";
        }
      }

    };

    const handleRightClick = (e) => {      
      insertModeRef.current = false;
      insertCellRef.current = null;
      if (previewRef.current) {
        e.preventDefault(); // prevent the default context menu
        previewRef.current.remove();
        previewRef.current = null;
      }
      handleCloseInstance()
      setDialogKey(prev => prev + 1);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("contextmenu", handleRightClick);
    // Cleanup both listeners
    return () => {
      if(graphRefs.current[activeTab] !== undefined){
        graphRefs.current[activeTab].getModel().removeListener(modelListener);
      }

      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, [graphRefs.current[activeTab]]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Check if any tab has unsaved changes
      const hasUnsavedChanges = Object.values(saveEnabled).some(enabled => enabled === true);
      
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = mxResources.get("changesLost") || "You have unsaved changes. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [saveEnabled]);

  const hasCreatedTab = useRef(false);

  useEffect(() => {
    if (location.state?.payload && !hasCreatedTab.current) {
      hasCreatedTab.current = true;
      const payload = location.state.payload;
      if (payload.view_type_id === VIEW_TYPES.stick) {
        createStickDiagram(payload);
      } else {
        handleEditCell(payload);
      }

      // Clear state to avoid duplicate creation on back
      window.history.replaceState({}, document.title);
    }
  }, []);

  useEffect(() => {
    pinQueueRef.current = pinQueue;
  }, [pinQueue]);

  const updateAllFontAndEdgeColors = (graph, isDarkMode) => {
    const edgeStrokeColor = "#38befe" 
    const fontColor = isDarkMode ? '#ffffff' : '#000000';
    const model = graph.getModel();
    const parent = graph.getDefaultParent();

    model.beginUpdate();
    try {
      const allEdges = graph.getChildEdges(parent);

      allEdges.forEach((edge) => {
        let style = model.getStyle(edge) || "";

        // Replace or add strokeColor in style string
        if (style.includes("strokeColor=")) {
          style = style.replace(
            /strokeColor=[^;]*/,
            `strokeColor=${edgeStrokeColor}`
          );
        } else {
          style += `;strokeColor=${edgeStrokeColor}`;
        }
        // Update fontColor
        if (style.includes("fontColor=")) {
          style = style.replace(/fontColor=[^;]*/, `fontColor=${fontColor}`);
        } else {
          style += `;fontColor=${fontColor}`;
        }
        // Ensure label background is transparent so text is readable in both modes
        if (style.includes("labelBackgroundColor=")) {
          style = style.replace(/labelBackgroundColor=[^;]*/, "labelBackgroundColor=none");
        } else {
          style += ";labelBackgroundColor=none";
        }
        model.setStyle(edge, style);
      });

      // Update all vertices (instances) and their port children
      const allVertices = graph.getChildVertices(parent);
      allVertices.forEach((vertex) => {
        let style = model.getStyle(vertex) || "";

        // Skip symbol view if necessary
        if (style.includes("shape=rectangle")) {
          return; // skip font update for symbols
        }
        
        // Update fontColor
        if (style.includes("fontColor=")) {
          style = style.replace(/fontColor=[^;]*/, `fontColor=${fontColor}`);
        } else {
          style += `;fontColor=${fontColor}`;
        }
        model.setStyle(vertex, style);

        // Update port child cells (ellipse ports inside instance vertices)
        const portChildren = graph.getChildVertices(vertex);
        portChildren.forEach((portCell) => {
          let portStyle = model.getStyle(portCell) || "";
          if (portStyle.includes("fontColor=")) {
            portStyle = portStyle.replace(/fontColor=[^;]*/, `fontColor=${fontColor}`);
          } else {
            portStyle += `;fontColor=${fontColor}`;
          }
          model.setStyle(portCell, portStyle);
        });
      })

    } finally {
      model.endUpdate();
    }
    graph.refresh();
  }

    const checkIfDiagramIsEmpty = () => {
    if (graphRefs.current[activeTab]) {
      const hasVertices =
        graphRefs.current[activeTab].getChildVertices(graphRefs.current[activeTab].getDefaultParent()).length === 0;
      setIsDiagramEmpty(hasVertices);
    }
  };

  const handleInstanceClick = async (shapeType, iconPath, label, library, cellId, viewId) => {
    selectedShapeTypeRef.current = shapeType;
    selectedIconPathRef.current = iconPath;
    currentInstancePrefixRef.current = 'i';
    const fontColor = isDarkMode ? '#ffffff' : '#000000';
    console.log("shapeType", shapeType);
    let style = `shape=${shapeType};labelPosition=center;verticalLabelPosition=top;align=center;verticalAlign=bottom;spacingLeft=-20;fontColor=${fontColor}`;
    const shapeConfig = shapeConfigRegistry[shapeType];

    // Custom style for no-conn
    if (shapeConfig?.style) {
      style = typeof shapeConfig.style === "function"
        ? shapeConfig.style(fontColor)
        : shapeConfig.style;
    }
    let vertex = null ;
    if (shapeConfig) {
      vertex = new mxCell("", new mxGeometry(0, 0, shapeConfig.width, shapeConfig.height), style);

      if (shapeConfig.ports?.length) {
        const pinStyle = `shape=ellipse;perimeter=ellipsePerimeter;resizable=0;movable=0;connectable=1;fillColor=#21b04c;strokeColor=#21b04c;fontColor=${fontColor}noLabel=1;fontSize=0`;
        shapeConfig.ports.forEach(({ name, label, x, y }) => {
          const pinGeo = new mxGeometry(x, y, 10, 10);
          pinGeo.relative = true;
          pinGeo.offset = new mxPoint(-5, -5);
          const pinCell = new mxCell(label, pinGeo, pinStyle);
          // Persist terminal name in XML for easier netlisting
          if (name) pinCell.name = name;
          pinCell.setVertex(true);
          pinCell.setConnectable(true);
          vertex.insert(pinCell);
          // pinCell.value = name;   
        });
      }
    }
    else if(shapeType === 'symbol'){      
      let data = null;
      // Fetch symbol specification data if viewId is provided
      if (viewId) {
        try {
          const response = await getSymbolSpecificationByViewId(viewId);
          if(!response.success) return;
          data = response.body;          
        } catch (error) {
          console.error('Failed to fetch symbol specification:', error);
        }

        const pinLength = 50; //TODO:to be fecthced from constant
        // Determine which sides have pins
        const hasTopPins    = data.pins.some(pin => pin.position === 'top');
        const hasBottomPins = data.pins.some(pin => pin.position === 'bottom');
        const hasLeftPins   = data.pins.some(pin => pin.position === 'left');
        const hasRightPins  = data.pins.some(pin => pin.position === 'right');
        let marginTop    = hasTopPins ? pinLength : 0;
        let marginBottom = hasBottomPins ? pinLength : 0;
        let marginLeft   = hasLeftPins ? pinLength : 0;
        let marginRight  = hasRightPins ? pinLength : 0;

        const outerWidth  = data.rect.width  + marginLeft + marginRight;
        const outerHeight = data.rect.height + marginTop + marginBottom;
        vertex = new mxCell("", new mxGeometry(0, 0, outerWidth, outerHeight), style);
        vertex.symbolSpec = data;
        vertex.symbolViewId = viewId;
        vertex.symbolName = label;

        // Add child port ellipses instead of mxConnectionConstraint
        const pinStyle = `shape=ellipse;perimeter=ellipsePerimeter;resizable=0;movable=0;connectable=1;fillColor=#21b04c;strokeColor=#21b04c;fontColor=${fontColor}`;
        (data.pins || []).forEach((pin) => {
          let x = 0.5;
          let y = 0.5;
          switch (pin.position) {
            case 'top':
              x = (marginLeft + pin.value * data.rect.width) / outerWidth;
              y = 0;
              break;
            case 'bottom':
              x = (marginLeft + pin.value * data.rect.width) / outerWidth;
              y = 1;
              break;
            case 'left':
              x = 0;
              y = (marginTop + pin.value * data.rect.height) / outerHeight;
              break;
            case 'right':
              x = 1;
              y = (marginTop + pin.value * data.rect.height) / outerHeight;
              break;
            default:
              return;
          }

          const pinGeo = new mxGeometry(x, y, 10, 10);
          pinGeo.relative = true;
          pinGeo.offset = new mxPoint(-5, -5);
          const pinCell = new mxCell('', pinGeo, pinStyle);
          pinCell.name = pin.name;
          pinCell.position = pin.position;
          pinCell.pinType = pin.type;
          pinCell.setVertex(true);
          pinCell.setConnectable(true);
          vertex.insert(pinCell);
        });
      }
    }
    else {
      vertex = new mxCell("", new mxGeometry(0, 0, 120, 70), style);
    }
    vertex.setConnectable(true);
    // shapes with port children: body is not connectable, only the port ellipses are
    if (shapeConfigRegistry[shapeType]?.ports?.length) {
      vertex.setConnectable(false);
    }
    if (shapeType === 'symbol' && vertex?.symbolSpec?.pins?.length) {
      vertex.setConnectable(false);
    }
    vertex.geometry.offset = new mxPoint(18,18);
    vertex.setVertex(true);
    // startDragAndDrop(graph, vertex, iconPath);
    insertModeRef.current = true;
    vertex.libraryId = library;
    vertex.cellId = cellId;
    vertex.shapeType= shapeType;
    insertCellRef.current = vertex;
    const ghost = document.createElement("img");
    ghost.src = iconPath;
    ghost.style.position = "absolute";
    ghost.style.pointerEvents = "none";
    ghost.style.opacity = "0.6";
    ghost.style.zIndex = "9999";
    if (shapeConfig) {
      ghost.style.width  = `${shapeConfig.width}px`;
      ghost.style.height = `${shapeConfig.height}px`;
    } else {
      ghost.style.width = "120px";
      ghost.style.height = "70px";
    }

    // document.body.appendChild(ghost);
    const container = containerRefs.current[activeTab];
    if (container) {
      container.appendChild(ghost);
      previewRef.current = ghost;
    }
    previewRef.current = ghost; 
    ensureTabInstanceState(activeTab);
    const name = getNextInstanceNameForTab(activeTab, 'i');
    setNextInstanceName(name); 
    if(shapeType=="no-conn"){
      setNextInstanceName("no-conn");
    }

    let lastX = 0, lastY = 0;

    const moveGhost = () => {
      if (!container) return;
      const { scrollLeft, scrollTop } = container;
      const { left, top } = container.getBoundingClientRect();
      const x = lastX - left + scrollLeft - ghost.offsetWidth  * 0.5;
      const y = lastY - top  + scrollTop  - ghost.offsetHeight * 0.5;
      ghost.style.left = x + "px";
      ghost.style.top  = y + "px";

    };

    // track mouse
    window.addEventListener("mousemove", e => {
      lastX = e.clientX;
      lastY = e.clientY;
      moveGhost();
    });

    // resync when the container scrolls
    container.addEventListener("scroll", moveGhost);
  };

  const handlePinCellSelect = (data) => {
    clearPinPlacement();
    if (!data) {
      // Cleanup if null or undefined is passed
      insertModeRef.current = false;
      insertCellRef.current = null;

      if (previewRef.current) {
        previewRef.current.remove();
        previewRef.current = null;
      }

      return; // Stop further execution
    }

    const { shapeType, imagePath, labels, library } = data;
    handlePinClick(shapeType, imagePath, labels , library);
  };

  const handlePinClick = (shapeType, iconPath, labels, library) => {
    if (!labels || labels.length === 0) return;

    setPinQueue(labels); // store full queue
    pinQueueRef.current = labels;

    const firstLabel = labels[0];
    createGhostPin(shapeType, iconPath, firstLabel, library); // extracted logic below
  };

  const createGhostPin = (shapeType, iconPath, label, library) => {
    let height = 20;
    let width = shapeType === "inout" ? 40 : 30;

    selectedShapeTypeRef.current = shapeType;
    selectedIconPathRef.current = iconPath;

    const fontColor = isDarkMode ? '#ffffff' : '#000000';
    const labelPosition = shapeType === 'in' ? 'left' : 'right';
    const style = `shape=${shapeType};labelPosition=${labelPosition};align=center;fontColor=${fontColor}`;
    const vertex = new mxCell(label, new mxGeometry(0, 0, width, height), style);
    vertex.setVertex(true);
    vertex.shapeType= shapeType;
    vertex.library = library;
    vertex.shapeType = shapeType;

    insertModeRef.current = true;
    insertCellRef.current = vertex;

    const ghost = document.createElement("img");
    ghost.src = iconPath;
    ghost.style.position = "absolute";
    ghost.style.width = `${width}px`;
    ghost.style.height = "30px";
    ghost.style.pointerEvents = "none";
    ghost.style.opacity = "0.6";
    ghost.style.zIndex = "9999";

    const container = containerRefs.current[activeTab];
    if (container) {
      container.appendChild(ghost);
      previewRef.current = ghost;
    }

    ensureTabInstanceState(activeTab);
    setNextInstanceName(getNextInstanceNameForTab(activeTab, 'i'));

    let lastX = 0, lastY = 0;

    const moveGhost = (e) => {
      if (!container || !previewRef.current) return;

      const { scrollLeft, scrollTop } = container;
      const { left, top } = container.getBoundingClientRect();

      const x = lastX - left + scrollLeft - ghost.offsetWidth * 0.5;
      const y = lastY - top + scrollTop - ghost.offsetHeight * 0.5;

      ghost.style.left = `${x}px`;
      ghost.style.top = `${y}px`;
    };

    // Save handlers to window so they can be removed later
    window.moveGhostHandler = (e) => {
      lastX = e.clientX;
      lastY = e.clientY;
      moveGhost(e);
    };

    window.scrollGhostHandler = () => moveGhost();

    // Attach event listeners
    window.addEventListener("mousemove", window.moveGhostHandler);
    container.addEventListener("scroll", window.scrollGhostHandler);
  };

  const clearPinPlacement = () => {
    insertModeRef.current = false;
    insertCellRef.current = null;
    pinQueueRef.current = [];
    setPinQueue([]);

    if (previewRef.current) {
      previewRef.current.remove();
      previewRef.current = null;
    }

    // Remove ghost event listeners
    if (window.moveGhostHandler) {
      window.removeEventListener("mousemove", window.moveGhostHandler);
      window.moveGhostHandler = null;
    }

    const container = containerRefs.current[activeTab];
    if (container && window.scrollGhostHandler) {
      container.removeEventListener("scroll", window.scrollGhostHandler);
      window.scrollGhostHandler = null;
    }

    selectedShapeTypeRef.current = '';
    selectedIconPathRef.current = '';
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOpenNewCell = () => {
    setNewCellOpen(true)
    handleMenuClose();
  };

  const handleOpenEditCell = () => {
    setEditCellDialog(true);
    handleMenuClose();
  };

  const handleOpenAddInstance = () => {
    setSelectedGraphCell(null);
    currentInstancePrefixRef.current = 'i';
    ensureTabInstanceState(activeTab);
    setNextInstanceName(getNextInstanceNameForTab(activeTab, 'i'));
    setIsEditInstance(false);
    setIsInstanceMinimized(false);
    setOpenAddInstance(true);
    handleMenuClose();
  };

  const handleHideInstance = () => {
    setOpenAddInstance(false);
    setIsInstanceMinimized(true);
  };

  const handleRestoreInstance = () => {
    setIsInstanceMinimized(false);
    setOpenAddInstance(true);
  };

  const handleCloseInstance = () => {
    setIsInstanceMinimized(false);
    setOpenAddInstance(false);
  };

  const handleOpenAddPin = () => {
  setOpenAddPin(true);
  handleMenuClose();
  setIsEditPin(false);
  setEditPinName('');
};

const handleOpenAddSymbol= () => {
  setOpenAddSymbol(true);
  handleMenuClose();
};
  
    // Handle tab change
  const handleTabChange = (event, newValue) => {
    const currentGraph = graphRefs.current[activeTab];

    if (currentGraph) {
      currentGraph.clearSelection(); // Prevent deletion on tab switch
    }
    setActiveTab(newValue);
  };
  
    const loadDiagramXmlIntoGraph = async (graph, view_id, tabId) => {
      
      if (!graph || !view_id) return;

      try {
        const response = await getViewById(view_id);
        if(!response.success) return;
        var data = response.body;
        let wrappedXml = wrapMxGraphModel(data.diagram_xml);
        let xmlString = addStylesBackToXml(wrappedXml);
        const parser = new DOMParser();
        const parsedXmlDoc = parser.parseFromString(xmlString, "application/xml");

        const symbolCells = Array.from(parsedXmlDoc.querySelectorAll('mxCell[style*="shape=symbol"]'));
        for (const cell of symbolCells) {
          const symbolViewId = cell.getAttribute("symbolViewId");
          if (!symbolViewId) continue; // skip if no symbolViewId

          const symbolSpecResponse = await getSymbolSpecificationByViewId(symbolViewId);
          if(!symbolSpecResponse.success) return;
          var symbolSpec = symbolSpecResponse.body; 
          
          if (!symbolSpec) continue;

          const pinsJson = symbolSpec.pins || [];
          const rectSpec = symbolSpec.rect;


          const pinsArrayNode = cell.querySelector('Array[as="pins"]');
          if (pinsArrayNode) {
            // Remove old pins
            while (pinsArrayNode.firstChild) {
              pinsArrayNode.removeChild(pinsArrayNode.firstChild);
            }

            // Add new pins
            pinsJson.forEach(pin => {
              const objNode = parsedXmlDoc.createElement("Object");
              objNode.setAttribute("name", pin.name);
              objNode.setAttribute("type", pin.type);
              objNode.setAttribute("value", pin.value !== null ? pin.value : "");
              objNode.setAttribute("position", pin.position);
              pinsArrayNode.appendChild(objNode);
            });
          }

          const rectNode = cell.querySelector('Object[as="rect"]');
          if (rectNode && rectSpec) {
            rectNode.setAttribute("x", rectSpec.x);
            rectNode.setAttribute("y", rectSpec.y);
            rectNode.setAttribute("width", rectSpec.width);
            rectNode.setAttribute("height", rectSpec.height);
          }
        }

        const serializer = new XMLSerializer();
        xmlString = serializer.serializeToString(parsedXmlDoc);

        window["mxGraphModel"] = mxGraphModel;
        window["mxGeometry"] = mxGeometry;
        window["mxPoint"] = mxPoint;

        const xmlDoc = mxUtils.parseXml(xmlString);
        const codec = new mxCodec(xmlDoc);
        const node = xmlDoc.documentElement;

        graph.getModel().beginUpdate();
        try {
          codec.decode(node, graph.getModel());
        } finally {
          graph.getModel().endUpdate();
        }

        // Update font colors to match current theme after loading
        updateAllFontAndEdgeColors(graph, isDarkMode);
        rebuildInstanceStateForTab(tabId, graph);

        // This prevents undo from reverting the loaded diagram
        if (commonRefs.current[tabId]) {
          commonRefs.current[tabId]._undoManager.clear();
        }

        setSaveEnabled(prev => ({ ...prev, [tabId]: false }));
      } catch (err) {
        console.error("Failed to load diagram XML:", err);
      }
    };

    // Handle creating a new tab
    const handleCreateSchematic = ( payload ) => {
      
      if (payload.cell_name.trim() === "") return;
      
      setGraphType(VIEW_TYPES.schematic);

      // Clear selection from current active graph (like in handleTabChange)
      if (graphRefs.current[activeTab]) {
        graphRefs.current[activeTab].clearSelection(); // Prevent deletion of selected graph cells when adding new tab
      }
  
      const newTabId = `tab${Date.now()}`;
      const newTab = {
        id: newTabId,
        name: payload.cell_name,
      };
      setTabs((prev) => [...prev, newTab]);
      instanceCountersRef.current[newTabId] = { i: 1 };
      instancesMapRef.current[newTabId] = {};
      setActiveTab(newTabId);

      if(!!payload.view_id){
        setCellViewPayload(prev => ({
          ...prev,
          [newTabId]: {
            view_id: payload.view_id,
            cell_id : payload.cell_id,
            view_type_id: payload.view_type_id
          }
        }));

        // Load XML directly after graph initialization
        setTimeout(() => {
          const graph = graphRefs.current[newTabId];

          if (graph && payload.view_id) {
            loadDiagramXmlIntoGraph(graph, payload.view_id, newTabId);
          }
        }, 100);
      } else{
        // Store associated payload data for this tab
        setCellViewPayload(prev => ({
          ...prev,
          [newTabId]: {
            cell_name: payload.cell_name,
            cell_id: payload.cell_id,
            library_id: payload.library_id,
            view_name: payload.view_name,
            view_type_id: payload.view_type_id,
            view_id: payload.view_id
          }
        }));
    }

      setDialogOpen(false);
    };

    const handleCellViewSelect = (data) => {
      if (!data) {
        // Cleanup if null or undefined is passed
        insertModeRef.current = false;
        insertCellRef.current = null;

        if (previewRef.current) {
          previewRef.current.remove();
          previewRef.current = null;
        }

        return; // Stop further execution
      }

      const { shapeType, imagePath, label, libraryId, cellId , viewId } = data;
      handleInstanceClick(shapeType, imagePath, label, libraryId, cellId, viewId); // existing logic for preview and placement
    };
  
    const handleCloseTab = (tabIdToRemove) => {
      setTabs((prevTabs) => {
        const filteredTabs = prevTabs.filter((tab) => tab.id !== tabIdToRemove);
        // Adjust active tab if the one being closed is active
        if (activeTab === tabIdToRemove && filteredTabs.length > 0) {
          setActiveTab(filteredTabs[0].id);
        }
  
        return filteredTabs;
      });

      // Remove cellViewPayload so it doesn't block duplicate checks in NewCellDialog
      setCellViewPayload((prev) => {
        const updated = { ...prev };
        delete updated[tabIdToRemove];
        return updated;
      });
  
      // Clean up references
      delete containerRefs.current[tabIdToRemove];
      delete graphRefs.current[tabIdToRemove];
      delete commonRefs.current[tabIdToRemove];
      delete instancesMapRef.current[tabIdToRemove];
      delete instanceCountersRef.current[tabIdToRemove];
  
      setGraphReadyTabs((prev) => {
        const updated = { ...prev };
        delete updated[tabIdToRemove];
        return updated;
      });
    };
  
    const handleContextMenu = (event) => {
      //If the previewRef instance is not null, the context menu should not be displayed. 
      // Instead, previewRef should be cleared, and the operation should return immediately to prevent the context menu from appearing.
      if(previewRef.current){ 
        return;
      }
      event.preventDefault();
      const container = containerRefs.current[activeTab];
      const rect = container.getBoundingClientRect();
      setMenuPosition({
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      });
      setMenuVisible(true);
    };
  
    // const handleCloseMenu = () => setMenuVisible(false);
  
    // const handleMenuClick1 = ( adjustedPosition = null) => {
    //   if (adjustedPosition) {
    //     setMenuPosition(adjustedPosition);
    //   }
    // };

  // const [openHeader, setOpenHeader] = useState(true);
  // const handleToggle = () => {
  //   setOpenHeader((prev) => !prev);
  // };

  const handleInstanceRename = (newName, options = {}) => {
    const trimmedName = (newName || '').trim();
    isInstanceNameValidRef.current = options.isValid !== false;
    currentInstanceNameRef.current = trimmedName;
    if (!selectedGraphCell) return;
    if (trimmedName === (selectedGraphCell.value || '').trim()) return;

    const oldName = selectedGraphCell.value;

    if (!isInstanceNameAvailable(trimmedName, activeTab, selectedGraphCell)) {
      console.warn("Instance name already exists.");
      return;
    }

    const graph = graphRefs.current[activeTab];
    if (!graph) return;

    graph.getModel().beginUpdate();
    try {
      graph.getModel().setValue(selectedGraphCell, trimmedName);
      graph.refresh(selectedGraphCell);
    } finally {
      graph.getModel().endUpdate();
    }

    unregisterInstanceName(activeTab, oldName);
    registerInstanceName(activeTab, trimmedName, selectedGraphCell, selectedGraphCell.style, selectedGraphCell.libraryId);

    setNextInstanceName(trimmedName);
  };

  const handlePinRename = (newName) => {
    if (!selectedGraphCell || newName === selectedGraphCell.value) return;

    const oldName = selectedGraphCell.value;

    // Prevent duplicate pin names
    if (pinMapRef.current?.[newName]) {
      console.warn("Pin name already exists.");
      return;
    }

    const graph = graphRefs.current[activeTab];
    if (!graph) return;

    const model = graph.getModel();
    model.beginUpdate();
    try {
      // Rename the pin cell itself
      model.setValue(selectedGraphCell, newName);

      // Cascade rename to all *explicit* net edge labels that used this pin name.
      const parent = graph.getDefaultParent();
      const allEdges = graph.getChildEdges(parent);
      const trimmedNewName = (newName || '').trim();
      allEdges.forEach((edge) => {
        const ev = model.getValue(edge);
        if (typeof ev !== 'string') return;
        const trimmed = ev.trim();
        if (!trimmed) return;
        // Only rename user-visible labels; skip hidden auto nets (noLabel=1)
        if ((edge.style || '').includes('noLabel=1')) return;
        if (trimmed !== oldName) return;

        // If pin name is cleared, revert this net back to an auto name (net_#)
        // instead of leaving a blank edge value.
        if (!trimmedNewName) {
          applyNetLabel(graph, edge, '', isDarkMode, netCountersRef, activeTab);
        } else {
          model.setValue(edge, trimmedNewName);
        }
      });

      // Keep *explicit* port net-labels consistent with pin rename.
      // Only update ports whose value is a non-empty string exactly equal to oldName.
      // Do NOT touch terminal identity (p.name = G/D/S/vin/...) and do not update cleared labels.
      const allVertices = graph.getChildVertices(parent);
      allVertices.forEach((v) => {
        const childPorts = graph.getChildVertices(v) || [];
        childPorts.forEach((p) => {
          const v = model.getValue(p);
          if (typeof v !== 'string') return;
          const trimmed = v.trim();
          if (!trimmed) return;
          if (trimmed === oldName) model.setValue(p, newName);
        });
      });

      graph.refresh();
    } finally {
      model.endUpdate();
    }

    // Update pins map
    if (pinMapRef.current?.[oldName]) {
      pinMapRef.current[newName] = pinMapRef.current[oldName];
      pinMapRef.current[newName].cell = pinMapRef;
      delete pinMapRef.current[oldName];
    }
  };


  // Net label dialog handlers
  const handleNetLabelConfirm = () => {
    const graph = graphRefs.current[activeTab];
    if (!graph || !editingNetCell) return;

    const newLabel = netLabelValue.trim();
    const model = graph.getModel();

    model.beginUpdate();
    try {
      if (model.isEdge(editingNetCell)) {
        applyNetLabel(graph, editingNetCell, newLabel, isDarkMode, netCountersRef, activeTab);
      } else {
        model.setValue(editingNetCell, newLabel);
      }
    } finally {
      model.endUpdate();
    }

    setOpenNetLabelDialog(false);
    setEditingNetCell(null);
    setNetLabelValue('');
  };

  const handleNetLabelClose = () => {
    setOpenNetLabelDialog(false);
    setEditingNetCell(null);
    setNetLabelValue('');
  };

  const handleShowNetlist = async () => {
    try {
      const data = cellViewPayload[activeTab];
      const viewId = data.view_id;
      const cellName = tabs.find((t) => t.id === activeTab)?.name || 'cell';

      const netlistResponse = await getNetlistByViewId(viewId, cellName);

      if (!netlistResponse?.success) {
        console.error("Netlist API failed");
        return;
      }

      const { spice } = netlistResponse.body.data;

      setNetlistText(spice);
      setOpenNetlistDialog(true);

    } catch (err) {
      console.error("Netlist fetch error:", err);
    }
  };

  const handleCopyNetlist = () => {
    navigator.clipboard.writeText(netlistText).catch(() => {});
  };

    //To get all constraints of a cell. (This method is used to get the constraints)
    function getAllConstraints(graph, cell) {
      const state = graph.view.getState(cell);
      if (!state) return [];

      // Uses the built-in constraint handler
      const constraints = graph.getAllConnectionConstraints(state) || [];
      return constraints;
    }

    function isConstraintPointConnected(graph, cell, constraint) {
      let connected = false;
      // Loop through edges of this cell
      const edgeCells = graph.getModel().getEdges(cell);
      
      if (edgeCells) {
        for (let edgeCell of edgeCells) {
          
          const srcCell = graph.getModel().getTerminal(edgeCell, true);
          const trgCell = graph.getModel().getTerminal(edgeCell, false);
          const edgeState = graph.getView().getState(edgeCell);

          let sc, tc;
          if (srcCell === cell) {
            sc = graph.getConnectionConstraint(edgeState, graph.view.getState(cell), true);
            // check if sc matches the constraint
          }

          if (trgCell === cell) {
            tc = graph.getConnectionConstraint(edgeState, graph.view.getState(cell), false);
            // check if tc matches the constraint
          }
          // Compare with this constraint
          if (
            (sc && sc.point && sc.point.equals(constraint.point)) ||
            (tc && tc.point && tc.point.equals(constraint.point))
          ) {
            connected = true;
            if (constraint.name === "G" && connected) {
               console.log("gate Edge", edgeCell);
            }

            break;
          }
        }
      }      
      let shape = cell.style.split(';')[0].trim();
      let cellType = shape.slice(shape.indexOf("=") + 1);

    
      // console.log({
      //   celltype: cellType,
      //   cellname: cell.value,
      //   constraint: constraint.name,
      //   point: constraint.point,
      //   connected,
      // })


      return {
        celltype: cellType,
        cellname: cell.value,
        constraint: constraint.name,
        point: constraint.point,
        connected,
      };
    }

    const checkAndSave = async () => {
      const graph = graphRefs.current[activeTab];
      const model = graph.getModel();
      var validatedConstraints = [];

      model.cells &&
        Object.values(model.cells).forEach((cell) => {
          if (cell.id == 0 || cell.id == 1) {
            //skipping root cells
            //console.log("root cells");
          } else if (cell.edge) {
            //edge only cells checking with edge attribute
            //console.log("skipping edge cells");
          } else if (cell.vertex) {
            //vertex only cells. checking vertex attribute
            const constraints = getAllConstraints(graph, cell);
            constraints.forEach((constraint, index) => {
              const constraintConnected = isConstraintPointConnected(graph, cell, constraint);  
              validatedConstraints.push(constraintConnected);           
              
            });
          }
        });
        return validatedConstraints;
    };

    const handleSave = async () => {
      const data = cellViewPayload[activeTab];
      const graph = graphRefs.current[activeTab];

      if (!data || !graph) return;
      
      const constraintsInfo = [];
      const model = graph.getModel();
      const view = graph.getView();
      view.validate(); // ensure states are ready

      model.cells && Object.values(model.cells).forEach(cell => {
        if (cell.edge) {
          const edgeState = view.getState(cell);
          const source = cell.getTerminal(true);
          const target = cell.getTerminal(false);

          if (source && target) {
            const srcState = view.getState(source);
            const trgState = view.getState(target);

            const srcConstraint = graph.getConnectionConstraint(edgeState, srcState, true);
            const trgConstraint = graph.getConnectionConstraint(edgeState, trgState, false);

            // Helper to match with shape.constraints (to get name)
            function findConstraintName(shape, constraint) {
              if (!shape || !shape.constraints || !constraint) return null;
              return shape.constraints.find(c =>
                c.point.x === constraint.point.x &&
                c.point.y === constraint.point.y
              )?.name || null;
            }

            const srcName = findConstraintName(srcState?.shape, srcConstraint);
            const trgName = findConstraintName(trgState?.shape, trgConstraint);

            constraintsInfo.push({
              edgeId: cell.id,
              sourceCell: {
                id: source.id,
                name: graph.convertValueToString(source)
              },
              targetCell: {
                id: target.id,
                name: graph.convertValueToString(target)
              },
              sourceConstraint: {
                point: srcConstraint?.point,
                name: srcName
              },
              targetConstraint: {
                point: trgConstraint?.point,
                name: trgName
              }
            });
          }
        }
      });

      //console.log("connected constraints:", constraintsInfo);

      const encoder = new mxCodec();
      const node = encoder.encode(graph.getModel());
      const xml = mxUtils.getXml(node);
     
      const { cleanedXml, styleMap } = extractAndRemoveStyles(xml);
      const convertedXml = removeMxGraphWrappers(cleanedXml);

      try {

        let cell_id = data.cell_id;

        if (data.view_id) {
          const response = await updateViewDiagram({
            view_id: data.view_id,
            view_type_id: data.view_type_id,
            // diagram: {"field": "updated json"},
            // diagram:{},
            diagram_xml: convertedXml
          });
          if(!response.success) return;
          setCellViewPayload(prev => ({
            ...prev,
            [activeTab]: {
              ...prev[activeTab],
              diagram_xml: convertedXml
            }
          }));           
          if (data.view_type_id === VIEW_TYPES.schematic) toast.success("Your schematic is updated!");
          if (data.view_type_id === VIEW_TYPES.symbol) toast.success("Symbol updated successfully!");
        } else {
          // If cell doesn't exist yet, create it
          if (!cell_id) {
            const cellRes = await addCell({
              name: data.cell_name,
              library_id: data.library_id,
            });
            if (!cellRes.success) return;
            const cellData = cellRes.body;
            cell_id = cellData.cell_id;
          }
          const response = await addView({
            name: data.view_name,
            cell_id,
            view_type_id: data.view_type_id,
            // diagram: {"field": "0"},
            // diagram:{},
            diagram_xml: convertedXml
          });
          if (!response.success) return;
          const res = response.body;
          // Save view_id back to state
          const newViewId = res.view_id;
          setCellViewPayload(prev => ({
            ...prev,
            [activeTab]: {
              ...prev[activeTab],
              cell_id,
              view_id: newViewId
            }
          }));               
          if (data.view_type_id === VIEW_TYPES.schematic) toast.success("Your schematic is created!");
          if (data.view_type_id === VIEW_TYPES.symbol) toast.success("Symbol created successfully!");     
        }

        setSaveEnabled(prev => ({ ...prev, [activeTab]: false }));

      } catch (err) {
        console.error('Save failed:', err);
        toast.error("Failed to save diagram. Please try again.");
      }
    };

    const handleMouseEvent = (event) => {
        if(event.type ==='mouseenter') {
          setAnchorEl(event.currentTarget);
        }
        else if(event.type ==='mouseleave')
        {
          setAnchorEl(null);
        }
        else if(event.type === 'click'){
          setAnchorEl(!menuOpen ? event.currentTarget : null);
        }
    };

    const handleSymbolSelect = async (payload) => {
      if (!payload) return;

      setGraphType(VIEW_TYPES.symbol);

      // Clear selection from current active graph
      if (graphRefs.current[activeTab]) {
        graphRefs.current[activeTab].clearSelection();
      }

      const newTabId = `tab${Date.now()}`;
      const newTab = {
        id: newTabId,
        name: payload.view_name,
      };
      setTabs((prev) => [...prev, newTab]);
      instanceCountersRef.current[newTabId] = { i: 1 };
      instancesMapRef.current[newTabId] = {};
      setActiveTab(newTabId);

      setSaveEnabled(prev => ({ ...prev, [newTabId]: payload.view_id ? false : true }));      
      if (!!payload.view_id) {
        const response = await getSymbolSpecificationByViewId(payload.view_id);
        if(!response.success) return;
        var data = response.body;

        const pins = data?.pins || [];
        const rect = data?.rect || [];

        // Store the symbol data for use in rectangle/pin creation
        setCellViewPayload((prev) => ({
          ...prev,
          [newTabId]: {
            cell_name: payload.cell_name,
            view_name: payload.view_name,
            view_type_id: payload.view_type_id,
            view_id: payload.view_id,
            pins: pins,
            rect: rect,
          },
        }));

        // Initialize graph with data directly
        setTimeout(() => {
          initializeGraphForSymbol(newTabId, payload, rect, pins);
        }, 0);
      } else {
        // Store the symbol data for use in rectangle/pin creation
        setCellViewPayload((prev) => ({
          ...prev,
          [newTabId]: {
            library_id: payload.library_id,
            library_name: payload.library_name,
            cell_id: payload.cell_id,
            cell_name: payload.cell_name,
            view_name: payload.view_name,
            view_type_id: payload.view_type_id,
            pins: payload.pins, // Pin data with positions, names and types
          },
        }));
      }
    };

    // const handleCloseDialog = () => {
    //   setOpenDialog(false);
    // };
    
  const createStickDiagram = (payload) => {
    const params = {
      lId: payload.library_id,
      lN: payload.library_name,
      cId: payload.cell_id,
      cN: payload.cell_name,      
      vN: payload.view_name,
    };

    if (payload.view_id) {
      params.vId = payload.view_id;
    }

    const encryptedParams = encodeURIComponent(encrypt(JSON.stringify(params)));
    window.open(`${window.location.origin}/stick?d=${encryptedParams}`, "_blank");
  }

  // Helper function to find existing tab by view_id
  const findExistingTabByViewId = (viewId) => {
    if (!viewId) return null;
    
    return tabs.find(tab => {
      const payload = cellViewPayload[tab.id];
      return payload && payload.view_id === viewId;
    });
  };

  // Create a unified handler for EditCellDiagram
  const handleEditCell = (payload) => {
    if (!payload) return;

    // Check if tab with this view_id already exists
    if (payload.view_id) {
      const existingTab = findExistingTabByViewId(payload.view_id);
      if (existingTab) {
        // Navigate to existing tab instead of creating new one
        setActiveTab(existingTab.id);
        return;
      }
    }
    
    // Route to appropriate handler based on view_type_id
    if (payload.view_type_id === VIEW_TYPES.symbol) {
      handleSymbolSelect(payload);
    } else {
      handleCreateSchematic(payload);
    }
  };

  const handleOutLineVisible = (newValue) => {
    setIsOutLineVisible((prev) => ({
      ...prev,
      [activeTab]: newValue,
    }));
  }
  
    return (
      <>
          <title>Schematic Editor</title>
          <meta name="description" content="Create or Edit Schematics" />
        
        <Box sx={{ display: "flex",flexDirection: "column",overflow: "hidden", height:'45px', padding:"5px", backgroundColor: "#e8ebeb"}}>
          <Collapse in={openHeader} >
            {/* <HeaderBar/> */}
          </Collapse>

          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" gap={1}>
            <Box onMouseEnter={handleMouseEvent} onMouseLeave={handleMouseEvent} >
              <Button
                variant="contained"
                disableElevation
                // endIcon={menuOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                onClick={handleMouseEvent}
                sx={{padding:"10px"}}
                className="customButtonStyle"
              >
                <Box display="flex" alignItems="center">
                  <span>Choose action</span>
                  <Divider className="button-divider" orientation="vertical" flexItem/>
                  {menuOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </Box>
              </Button>
                <Popper open={menuOpen} anchorEl={anchorEl} transition placement="bottom-start" sx={{ zIndex: 9999 }} >
                  {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                      <Paper>
                        <MenuList autoFocusItem={false}>
                          <MenuItem onClick={handleOpenNewCell}>
                            <NoteAddOutlinedIcon sx={{ fontSize: "medium", mr: 1 }} />
                            New Cell
                          </MenuItem>

                          <MenuItem onClick={handleOpenEditCell}>
                            <FileOpenOutlinedIcon sx={{ fontSize: "medium", mr: 1 }} />
                            Open/Edit Cell
                          </MenuItem>

                          <MenuItem onClick={handleOpenAddSymbol}>
                            <MemoryOutlinedIcon sx={{ fontSize: "medium", mr: 1 }} />
                            Create Symbol
                          </MenuItem>

                          <Divider />

                          <MenuItem onClick={handleOpenAddInstance} disabled={!tabs.length > 0 || (cellViewPayload[activeTab].view_type_id === VIEW_TYPES.symbol)}>
                            <DeveloperBoardOutlinedIcon sx={{ fontSize: "medium", mr: 1 }} />
                            Add Instance
                          </MenuItem>

                          <MenuItem onClick={handleOpenAddPin} disabled={!tabs.length > 0 || (cellViewPayload[activeTab].view_type_id === VIEW_TYPES.symbol)}>
                            <FiberPinOutlinedIcon sx={{ fontSize: "large", mr: 1 }} />
                            Add Pin
                          </MenuItem>
                        </MenuList>
                      </Paper>
                    </Grow >
                  )}
                </Popper>
            </Box>
             {isInstanceMinimized && (
                <MinimizedBar title="Add Instance" onRestore={handleRestoreInstance} onClose={handleCloseInstance} />
              )}
            </Box>
         
            {/* <Button
              variant="contained"
              onClick={handleSave}
              disabled={!saveEnabled?.[activeTab]}
              className="customButtonStyle"
              style={{
                backgroundColor: "#808080",
                textTransform: "none",
                marginRight: "10px",
              }}
            > Save
            </Button> */}

            <IconButton onClick={toggleHeader}>
            {openHeader ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
          </Box>
        </Box>

        {!graphReadyTabs[activeTab] && (<Box sx={{ p: { xs: 3, md: 8 } }} >
          <Typography variant="h1" sx={{ fontWeight: 700, mb: 1, fontSize: "40px", }}>
            Welcome to <span className="sniglet-font-text">PHYtool</span> editor
          </Typography>

          <Typography variant="h5" sx={{ p: 1, fontSize: "20px" }}>
            Start with the “Choose Action” menu to
          </Typography>

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", p: 2, mt: 5,}}>
            <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 2 }} >
              ADD NEW CELL
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              To create new cell
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 2 }}>
              OPEN AND UPDATE EXISTING CELLS
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Edit existing cells
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 2 }}>
              CREATE SYMBOLS
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              create new symbols
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 2 }} >
              ADD INSTANCE
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              adding new instances
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: "bold", letterSpacing: 2 }}>
              ADD PIN
            </Typography>
            <Typography variant="body1">
              Add pins
            </Typography>
          </Box>
        </Box>)}
  
  {/* ----------------------------------------------------- */}
  <Box sx={{ height: openHeader ? 'calc(100vh - 120px)' : 'calc(100vh - 45px)', display: 'flex', flexDirection: 'column'}}>
    <Grid container backgroundColor={'#ffffff'} sx={{ borderBottom: tabs.length > 0 ? '0.5px solid rgba(0, 0, 0, 0.1) ' : 'none' }}>

      {/* Scrollable Tabs */}
      <Grid size={6}>
        <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className="custom-tabs"
        variant="scrollable"
        scrollButtons="auto" 
        TabIndicatorProps={{
          style: { display: 'none'}, // Hide the default indicator
        }}>
          {tabs.map((tab) => (
          <Tab
            key={tab.id}
            value={tab.id}
            className="custom-graph-tab"
            sx={{
              backgroundColor: activeTab === tab.id ? '#ccc' : '#fff',
              color: activeTab === tab.id ? '#fff' : '#000',
              textTransform: 'none',
            }}
            label={
              <Tooltip title={tab.name}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <DeveloperBoardIcon sx={{ mr: 0.5 }} fontSize="small" />
                  {tab.name}

                  {/* Show unsaved icon if saveEnabled is true for this tab */}
                  {tabs.length > 0 && (
                    saveEnabled?.[tab.id] ? (
                      <IconButton
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        fontSize="small"
                        // sx={{color:'#7F141A'}}
                        onClick={() => {
                          setSelectedCellName(tab.name);
                          setSelectedTabId(tab.id);
                          setOpenUnsavedDialog(true);
                        }}
                        >
                        {isHovered ? <CloseIcon fontSize="small"/> :<FiberManualRecordIcon fontSize="small"/> }
                      </IconButton>                      
                      
                    ) : (
                      <CloseIcon 
                        fontSize="small" 
                        sx={{ ml: 1, mb:0.3 }}
                        onClick={(e) => {
                          e.stopPropagation(); // prevent tab switch
                          handleCloseTab(tab.id);
                        }} 
                      />
                    )
                  )}
                </Box>
              </Tooltip>
            }
          />
          ))}
        </Tabs>
      </Grid>

      <Grid size={6}>       
        {graphReadyTabs[activeTab] && (  
          <GraphToolbar
            graph={graphRefs.current[activeTab]}
            containerRef={containerRefs.current[activeTab]}            
            commonRef={commonRefs.current[activeTab]}
            isDarkMode={isDarkMode}
            toggleMode={toggleMode}
            isSelectionEmpty = {isSelectionEmpty}
            hasClipboardContent={hasClipboardContent}
            handleSave={handleSave}
            saveEnabled={saveEnabled?.[activeTab]}      
            checkAndSave= {checkAndSave}                  
            handleOutlineVisible={handleOutLineVisible}
            onShowNetlist={handleShowNetlist}
            diagramMode="schematicEditor"
          />      
        )}   
      </Grid>
          
    </Grid>
    {/* Graph Container */}
    {tabs.map((tab) => (
      <ThemeProvider key={tab.id} theme={localTheme}>
      <CssBaseline />
        <Grid
        id= {tab.id}
        key={tab.id}
        ref={(el) => (containerRefs.current[tab.id] = el)}
        tabIndex={0}
        onContextMenu={handleContextMenu}
        sx={{
          backgroundPosition: "-1px 0px",
          cursor: "default",
          overflow: "auto",
          flexGrow: 1,
          position: "relative",
          display: tab.id === activeTab ? "block" : "none",
          '&:focus': {
            outline: 'none', // Removes the focus border
          },
        }}
      >
      {/* {containerRefs.current[tab.id] && (
        <ContextMenu
          commonRef={commonRefs.current[tab.id]}
          visible={tab.id === activeTab && menuVisible}
          position={menuPosition}
          containerRef={{ current: containerRefs.current[tab.id] }}
          onClose={handleCloseMenu}
          onMenuClick={handleMenuClick1}
          isSelectionEmpty = {isSelectionEmpty}
        />
      )} */}
      </Grid>
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            id={`outlineContainer-${tab.id}`}
            className="outline-container"
            sx={{
              display: (tab.id === activeTab && isOutLineVisible[activeTab]) ? "block" : "none",
              position: "absolute",
              bottom: 10,
              right: 20,
              width: 200,
              height: 150,
              backgroundColor: "transparent",
              border: `2px solid ${isDarkMode ? '#ffffff' : '#000000'}`,
              zIndex: 1000,
              overflow: 'auto',
              pointerEvents: "auto", // fixed 'pointer' typo
            }}
            ref={(el) => {
              if (el) outlineRef.current[tab.id] = el;
            }}
          />
        ))}
      </ThemeProvider>
    ))}
          
        </Box>
  
        <NewCellDialog open={newCellopen}
          onClose={() => setNewCellOpen(false)}
          onCreate={handleCreateSchematic}
          cellViewPayload={cellViewPayload}
          onStickCreate={createStickDiagram}
          onOpenManageLibrary={() => { setOpenManageLibrary(true) }}
        />
        <ManageLibrary
          libraryPopupOpen={openManageLibrary}
          handleClose={() => setOpenManageLibrary(false)}
          userId={userId}
        />
        <EditCellDiagram editDialogOpen={editCellDialog} onClose={() => setEditCellDialog(false)} onCreate={handleEditCell} onStickCreate={createStickDiagram} />
        <AddInstanceDialog open={openAddInstance} onClose={handleCloseInstance}
          onHide={handleHideInstance}
          key={dialogKey} 
          onCellViewSelect={handleCellViewSelect}
          instanceName={nextInstanceName}
          onInstanceRename={handleInstanceRename}
          isEdit={isEditInstance}
          editInstanceName={editInstanceName}
          instancesMapRef={instancesMapRef}
          activeTab={activeTab}
          getNextInstanceName={() => getNextInstanceNameForTab(activeTab, 'i')}
          validateInstanceName={(name) => isInstanceNameAvailable(name, activeTab, isEditInstance ? selectedGraphCell : null)}
          onInstanceNameValidity={(isValid) => { isInstanceNameValidRef.current = isValid; }}
          viewTypeId={VIEW_TYPES.schematic}
          activeTabCellId={cellViewPayload[activeTab]?.cell_id} />
        <AddPinDialog open={openAddPin} onClose={() => setOpenAddPin(false)} onCellSelect={handlePinCellSelect}
          isEdit={isEditPin}
          editPinName={editPinName}
          onPinRename={handlePinRename}
          editPinShapeType={selectedGraphCell?.shapeType || ''} />
        <AddSymbol 
          open ={openAddSymbol} 
          onClose={() => setOpenAddSymbol(false)} 
          onCellSelect={handleSymbolSelect}
          onOpenManageLibrary={() => { setOpenManageLibrary(true) }}
        />
        <UnsavedDialog open={openUnsavedDialog} onClose={() => setOpenUnsavedDialog(false)} cellName={selectedCellName} handleSave={handleSave} handleTabClose={() => handleCloseTab(selectedTabId)}/>

        <NetlistDialog
          open={openNetlistDialog}
          onClose={() => setOpenNetlistDialog(false)}
          netlistText={netlistText}
          onCopy={handleCopyNetlist}
          isDarkMode={isDarkMode}
        />

        {/* Net label dialog — used for both wires and port ellipses */}
        <Dialog open={openNetLabelDialog} onClose={handleNetLabelClose} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontSize: '14px', pb: 1 }}>
            {editingNetCell && graphRefs.current[activeTab]?.getModel().isEdge(editingNetCell)
              ? 'Rename Net (Wire)'
              : 'Assign Net Label (Port)'}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              size="small"
              label="Net name"
              value={netLabelValue}
              onChange={(e) => setNetLabelValue(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleNetLabelConfirm(); }}
              placeholder="e.g. VDD, VSS, IN, OUT"
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleNetLabelClose} size="small">Cancel</Button>
            <Button onClick={handleNetLabelConfirm} variant="contained" size="small">Apply</Button>
          </DialogActions>
        </Dialog>
      </>
    );
  
  };

SchematicEditor.propTypes = {};

SchematicEditor.defaultProps = {};

export default SchematicEditor;
